<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 16rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4 py-6">
        <h1 class="text-white text-4xl md:text-5xl lg:text-6xl font-bold mb-3">Terms of Service</h1>
        <p class="text-gray-300 text-lg m-0">Using eszes.in and the Snapcart free local edition</p>
    </div>
</div>

<section class="bg-white py-6 md:py-8" data-prerender>
    <div class="px-4 md:px-6 lg:px-8">
        <div class="legal">
            <p class="meta">Last updated: 17 September 2026. These terms are between you and ESZES Consultancy &amp; Services ("ESZES", "we").
                Hosted BMS subscriptions are governed by the separate agreement each customer signs; where that agreement
                and these terms differ, the agreement prevails.</p>

            <h2>1. The website</h2>
            <p>eszes.in describes our products and services. Its content is provided for information and may change without
                notice. You may browse it and use the contact form for its intended purpose. You may not scrape it, probe or
                overload it, or submit content that is unlawful, misleading or infringes someone else's rights.</p>

            <h2>2. The Snapcart free local edition</h2>
            <h3>2.1 What it is</h3>
            <p>The free local edition is a set of BMS applications (currently BMS Items, BMS Ecom and BMS Ledger) that you download and run
                on your own computer under a licence file issued for that machine, together with a sign-in account we
                create for you.</p>
            <h3>2.2 Licence</h3>
            <p>Subject to these terms, ESZES grants you a personal, non-exclusive, non-transferable, revocable licence to
                install and run the free local edition on the computer whose MAC address you supplied, for evaluation and
                for your own business use. You may not:</p>
            <ul>
                <li>copy the licence file to another machine, or share your sign-in account;</li>
                <li>redistribute, sell, rent or sublicense the software or the kit;</li>
                <li>reverse engineer, decompile or modify the applications, except where the law expressly allows it;</li>
                <li>remove licence checks, branding or notices;</li>
                <li>use the software to provide a service to third parties, or to build a competing product.</li>
            </ul>
            <p>The software, the kit and all related documentation remain the property of ESZES and its licensors. No rights
                are granted other than those stated here.</p>
            <h3>2.3 Your data</h3>
            <p>Everything you create in the free local edition is stored on your computer and belongs to you. We do not have
                access to it. You are responsible for backing it up.</p>
            <h3>2.4 What is not included</h3>
            <p>The free local edition is provided without support obligations, service levels or updates, although we may
                publish updates from time to time. Some hosted features (document uploads, e-mail, online payments, loyalty,
                CRM sync, AI assistants) are not part of the kit. Sign-in depends on Amazon Cognito being reachable.</p>
            <h3>2.5 Term and termination</h3>
            <p>The licence runs for the period stated in the licence file and may be renewed on request. We may revoke a
                licence or account if these terms are breached, or discontinue the free local edition with reasonable
                notice on this website. On termination you must stop using the software and delete the kit and licence file;
                the data you created remains yours.</p>

            <h2>3. Accounts</h2>
            <p>Keep your sign-in credentials confidential and tell us promptly at <a href="mailto:info&#64;eszes.in">info&#64;eszes.in</a>
                if you believe they have been compromised. You are responsible for activity under your account.</p>

            <h2>4. Intellectual property</h2>
            <p>The BMS name, the ESZES and Snapcart marks, the logos and the content of this site are owned by ESZES.
                Third-party product names and trademarks belong to their respective owners and are used
                only to describe compatibility.</p>

            <h2>5. Disclaimer of warranties</h2>
            <p>The website and the free local edition are provided "as is" and "as available". To the fullest extent
                permitted by law, ESZES disclaims all warranties, express or implied, including merchantability, fitness for
                a particular purpose, accuracy and non-infringement. We do not warrant that the software will be error-free
                or uninterrupted, or that it will meet your requirements.</p>

            <h2>6. Limitation of liability</h2>
            <p>To the fullest extent permitted by law, ESZES will not be liable for any indirect, incidental, special,
                consequential or punitive damages, or for loss of profits, revenue, data or goodwill, arising from your use
                of the website or the free local edition. Our total liability for any claim relating to the free local
                edition, which is provided without charge, is limited to INR 5,000. Nothing in these terms excludes liability
                that cannot be excluded under Indian law.</p>

            <h2>7. Indemnity</h2>
            <p>You agree to indemnify ESZES against claims and costs arising from your breach of these terms or your misuse of
                the software.</p>

            <h2>8. Privacy</h2>
            <p>Our <a routerLink="/privacy">Privacy Policy</a> explains what personal data we collect and how we use it. It forms
                part of these terms.</p>

            <h2>9. Changes to these terms</h2>
            <p>We may revise these terms; the date at the top shows the current version. Continued use of the website or the
                free local edition after a change means you accept the revised terms.</p>

            <h2>10. Governing law and disputes</h2>
            <p>These terms are governed by the laws of India. The courts at Thrissur, Kerala have exclusive jurisdiction over
                any dispute, subject to any right you have under applicable consumer law.</p>

            <h2>11. Contact</h2>
            <p><strong>ESZES Consultancy &amp; Services</strong><br>Plot No. 36, Karuna, Pushpavihar, Nadathara, Thrissur 680751, Kerala, India<br>
                E-mail: <a href="mailto:info&#64;eszes.in">info&#64;eszes.in</a> · Phone: <a href="tel:+919895013318">+91 98950 13318</a></p>
        </div>
    </div>
</section>
